import React from 'react'
import {
    Button,
    Div,
    FormItem,
    FormLayout,
    Input,
    Textarea,
    DateInput,
    Avatar,
    ButtonGroup,
    PanelHeaderButton, PanelHeader
} from "@vkontakte/vkui";
import {
    Icon16Clear,
    Icon24BrowserBack,
    Icon24Story,
    Icon28Backspace,
    Icon28CheckCircleFill
} from "@vkontakte/icons";
import * as constants from "../assets/constants";
import {AdaptivityContext} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import axios from "axios";
import moment from "moment";
import StorageApi from "../api/StorageApi";
import item from "../references/Klients/item";

class SaleDocFFCMonitoring extends React.Component {

    constructor() {
        super();
        this.state = {
            items_monitoring: {},
            loading: false,
            date_error: '',
            photo_error: '',
            meters_error: '',
            numdoc_error: '',
            comment: '',
            datedoc: undefined,
            meters: null,
            numdoc: ''
        }
        window.addEventListener("message", this.receiveMessage, false)
    }

    clearPhoto = () => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}

        if (items[this.props.current_doc.doc_data.id] == undefined) {
            items[this.props.current_doc.doc_data.id] = {}
        }
        items[this.props.current_doc.doc_data.id].hasImage = false

        this.setState({items_monitoring: items})

        localStorage.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
        StorageApi.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
    }

    saveMonitoringData = () => {

        let items = this.state.items_monitoring ? this.state.items_monitoring : {}
        if (items[this.props.current_doc.doc_data.id] == undefined) {
            items[this.props.current_doc.doc_data.id] = {}
        }

        items[this.props.current_doc.doc_data.id].numdoc = this.state.numdoc
        items[this.props.current_doc.doc_data.id].datedoc = this.state.datedoc
        items[this.props.current_doc.doc_data.id].meters = this.state.meters
        items[this.props.current_doc.doc_data.id].comment = this.state.comment
    }
    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "setMonitoringImage") {
                let old = null

                let items = this.state.items_monitoring ? this.state.items_monitoring : {}
                if (items[this.props.current_doc.doc_data.id] == undefined) {
                    items[this.props.current_doc.doc_data.id] = {}
                } else {
                    old = items[this.props.current_doc.doc_data.id]
                }
                items[this.props.current_doc.doc_data.id].hasImage = true
                items[this.props.current_doc.doc_data.id].isConfirm = false
                items[this.props.current_doc.doc_data.id].mainImage = event.data.data.image
                items[this.props.current_doc.doc_data.id].numdoc = old ? old.numdoc : ''
                items[this.props.current_doc.doc_data.id].meters = old ? old.meters : 0
                items[this.props.current_doc.doc_data.id].datedoc = old ? old.datedoc : ''
                items[this.props.current_doc.doc_data.id].thumb = event.data.data.thumb
                items[this.props.current_doc.doc_data.id].datetime = new Date()


                this.setState({items_monitoring: items})

                localStorage.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
                StorageApi.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
                if (this.props.father) {
                    this.props.father.setState({activePanelReportFFC: 'add_monitoring_ffc_sale_doc_panel'});//, 1000);
                }

            }
        }

    }
    componentDidMount = () => {
        const {current_doc} = this.props
        const {doc_data} = current_doc
        const data = doc_data.meta.confirmFFC
        if (data) {
            data.datedoc = data.date ?? ''
        }
        const monitoring_photo = data ?? {
            hasImage: false,
            comment: '',
            numdoc: '',
            meters: 0,
            datedoc: undefined
        }
        const items = {}
        items[doc_data.id] = monitoring_photo

        this.setState({items_monitoring: items})
        if (data && data.datedoc) {
            const str = data.datedoc

            const [date, time] = str.split(" ");
            const [day, month, year] = date.split(".");
            const [hours, minutes] = time.split(":");
            data.datedoc = new Date(year, month - 1, day, hours, minutes)
        }
        this.setState({
            datedoc: monitoring_photo.datedoc ? new Date(monitoring_photo.datedoc) : undefined,
            numdoc: monitoring_photo.numdoc,
            meters: monitoring_photo.meters,
            comment: monitoring_photo.comment
        })

        window.addEventListener("message", this.receiveMessage, false)

    }
    componentWillUnmount = () => {
        localStorage.setItem(constants.photo_ffc_items_key, JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {}))
        StorageApi.setItem(constants.photo_ffc_items_key, JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {}))
        window.removeEventListener("message", this.receiveMessage)

    }


    getPhoto = () => {
        if (this.props.father) {
            this.props.father.setState({activePanelReportFFC: 'ffc_photo_panel'});//, 1000);
        }
    }

    render() {
        let images_url = this.props.base_url.replace("frontend/", '');

        const monitoring_photo = this.props.current_doc && this.state.items_monitoring[this.props.current_doc.doc_data.id] ? this.state.items_monitoring[this.props.current_doc.doc_data.id] : {hasImage: false}

        return (
            <Div>
                <PanelHeader before={
                    <PanelHeaderButton onClick={() => this.props.back()}
                                       key="cmd_back_add_monitoring_"><Icon24BrowserBack/></PanelHeaderButton>}>

                    Подтверждение отгрузки
                </PanelHeader>
                <FormLayout label="Введите данные">
                    <FormItem top="Дата заказа" status={this.state.date_error ? 'error' : 'default'}
                              bottom={this.state.date_error}>
                        <DateInput tabIndex="0"
                                   onChange={(e) => {
                                       this.setState({datedoc: e});
                                       this.saveMonitoringData()
                                   }}
                                   value={this.state.datedoc}
                                   status={this.state.date_error ? 'error' : 'default'}
                        />
                    </FormItem>
                    <FormItem top={"Номер заказа"}
                              status={this.state.numdoc_error ? 'error' : 'default'}
                              bottom={this.state.numdoc_error}>
                        <Input autoFocus tabIndex="1"
                               type="text"
                               value={this.state.numdoc}
                               onChange={(e) => {
                                   this.setState({numdoc: e.target.value});
                                   this.saveMonitoringData()
                               }}
                               status={this.state.numdoc_error ? 'error' : 'default'}
                        />
                    </FormItem>
                    {(this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') &&
                        <FormItem top="Количество м2" status={this.state.meters_error ? 'error' : 'default'}
                                  bottom={this.state.meters_error}>
                            <Input autoFocus tabIndex="1"
                                   type="number"
                                   placeholder="Количество квадратных метров в отгрузке"
                                   value={this.state.meters}
                                   onChange={(e) => {
                                       this.setState({meters: e.target.value});
                                       this.saveMonitoringData()
                                   }}
                                   status={this.state.meters_error ? 'error' : 'default'}
                            />
                        </FormItem>}
                    <FormItem top="Комментарий">
                        <Textarea tabIndex="1"
                                  type="text"
                                  value={this.state.comment}
                                  onChange={(e) => {
                                      this.setState({comment: e.target.value});
                                      this.saveMonitoringData()
                                  }}

                        />
                    </FormItem>
                    <FormItem top="Фото документа об отгрузке (накладная, чек или иной)"
                              status={this.state.photo_error ? 'error' : 'default'}
                              bottom={this.state.photo_error}>
                        <Fancybox key={'SaleDocsMonitoringFancyBox'}>
                            <div c_lassName="sale-doc-form_monitoring-avatar"
                                 style={{maxWidth: AdaptivityContext.isMobile ? '160px' : '240px'}}>
                                {monitoring_photo.hasImage ?

                                    [<a data-fancybox={'gallery' + this.props.current_doc.doc_data.id}
                                        href={images_url + monitoring_photo.mainImage.replace(images_url, '')}>
                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                 size={AdaptivityContext.isMobile ? 160 : 240}
                                                 src={monitoring_photo.thumb}/>}
                                    </a>,
                                        <ButtonGroup stretched>
                                            <Button mode="outline" stretched size="s"
                                                    onClick={() => {
                                                        this.getPhoto()
                                                    }}><Icon24Story/></Button>
                                            <Button mode="outline" stretched size="s"
                                                    onClick={() => {
                                                        this.clearPhoto()
                                                    }}><Icon16Clear/></Button>
                                        </ButtonGroup>]
                                    :
                                    <Avatar mode="image" style={{borderRadius: '5%'}}
                                            onClick={() => {
                                                this.getPhoto()
                                            }}
                                            size={AdaptivityContext.isMobile ? 160 : 260}
                                            src={images_url + constants.EMPTY_IMG}/>
                                }
                            </div>
                        </Fancybox>
                    </FormItem>
                    <ButtonGroup stretched>
                        <Button stretched size="l" mode="secondary" before={<Icon28CheckCircleFill/>}
                                onClick={() => this.validateForm()}>Сохранить</Button>
                        <Button stretched size="l" mode="secondary" before={<Icon28Backspace/>}
                                onClick={() => this.props.back()}>Отмена</Button>
                    </ButtonGroup>
                </FormLayout>
            </Div>
        )

    }

    sendConfirmFFC = (data) => {
        const body = new FormData()

        let sAjaxSource = '/?app=saledocs&act=setFFCConfirm'

        body.append('numdoc', data.numdoc);
        body.append('date', moment(data.datedoc).format(constants.simpleDateTimeFormat));
        body.append('comment', data.comment);
        body.append('hasImage', data.hasImage);
        body.append('meters', data.meters ?? 0);
        body.append('image', data.mainImage ? data.mainImage : 'Фото не сделано');
        body.append('id', this.props.current_doc.doc_data.id);

        this.setState({loading: true})
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        ).then((response) => {
            this.setState({loading: false})
            let items = this.state.items_monitoring ? this.state.items_monitoring : {}
            if (items[this.props.current_doc.doc_data.id] == undefined) {
                items[this.props.current_doc.doc_data.id] = {}
            }
            localStorage.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
            StorageApi.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
            this.props.back()
        }).catch((error) => {

            window.postMessage({
                type: 'error',
                text: 'Свяжитесь с техподдержкой scladro и сообщите ошибку: ' + error.message,
                timeout: 10000
            })
            this.props.back()

        });
    }
    validateForm = () => {
        let error = 0

        if (this.state.numdoc === undefined || this.state.numdoc == '') {
            error++
            this.setState({numdoc_error: 'Не указан номер заказа'})
        } else {
            this.setState({numdoc_error: ''})
        }

        if (this.state.datedoc === undefined || this.state.datedoc === null || this.state.datedoc == '') {
            error++
            this.setState({date_error: 'Не указана дата'})
        } else {
            this.setState({date_error: ''})
        }
        if ((this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') && !this.state.meters) {
            error++
            this.setState({meters_error: 'Нужно указать количество м2 в отгрузке'})
        } else {
            this.setState({meters_error: ''})
        }

        const monitoring_photo = this.props.current_doc && this.state.items_monitoring[this.props.current_doc.doc_data.id] ? this.state.items_monitoring[this.props.current_doc.doc_data.id] : {hasImage: false}

        /*        if (!monitoring_photo.hasImage) {
                    error++
                    this.setState({photo_error: 'Сделайте фото документа!'})
                } else {
                    this.setState({photo_error: ''})
                }*/
        if (error > 0) return

        let items = this.state.items_monitoring ? this.state.items_monitoring : {}

        if (items[this.props.current_doc.doc_data.id] == undefined) {
            items[this.props.current_doc.doc_data.id] = {}
        }
        //items[this.props.current_doc.doc_data.id].hasImage = true
        items[this.props.current_doc.doc_data.id].isConfirm = true
        items[this.props.current_doc.doc_data.id].numdoc = this.state.numdoc
        items[this.props.current_doc.doc_data.id].meters = this.state.meters
        items[this.props.current_doc.doc_data.id].comment = this.state.comment
        items[this.props.current_doc.doc_data.id].datedoc = this.state.datedoc

        this.setState({items_monitoring: items})

        localStorage.setItem(constants.photo_ffc_items_key, JSON.stringify(items))
        StorageApi.setItem(constants.photo_ffc_items_key, JSON.stringify(items))

        this.sendConfirmFFC(items[this.props.current_doc.doc_data.id])
    }
}

export default SaleDocFFCMonitoring